<!-- 取消图片组件的紧凑模式 2022年8月4日byzb -->
<template>
	<div>
		<van-cell
			class="ry-form__image-choose"
		>
			<template slot="title">
				<span class="title">{{current.title}}</span>
				<span
					style="color: red"
					v-if="!isRead && current.required"
				>*</span>
			</template>
			<template slot="label">

				<template v-if="current.fieldHint">
					<froalaView
						v-if="$store.getters.newRtf"
						v-model="current.fieldHint"
					></froalaView>
					<div
						v-else
						class="ql-editor"
						v-html="current.fieldHint"
					>
					</div>
				</template>
				<div
					class="ry-form__image-choose-isRead"
					v-if="isRead"
				>
					<div
						v-for="opt in contentText"
						class="ry-form__image-choose-content"
					>
						<div>
							<van-image
								width="80"
								height="80"
								:src="opt.optionImage"
								fit="cover"
							></van-image>
						</div>
						<span>{{ opt.optionName }}</span>
					</div>
				</div>

				<div v-if="isRead && (!current.value || !current.value.length)">
					暂无内容
				</div>

				<van-checkbox-group
					v-if="!isRead"
					:disabled="isReadOnly"
					@change="controlChange"
					v-model="current.value"
				>
					<van-checkbox
						v-for="(opt, idx) in current.options"
						icon-size="14"
						shape="square"
						color="#4260FA"
						:key="opt.id"
						:name="opt.id"
					>
						<div class="ry-form__image-choose-content">
							<div>
								<van-image
									width="80"
									height="80"
									:src="opt.optionImage"
									fit="cover"
								></van-image>
							</div>
							<span>{{ opt.optionName }}</span>
						</div>
					</van-checkbox>
				</van-checkbox-group>
			</template>
		</van-cell>

		<!-- <div
			v-else
			class="ry-form-item-compact ry-form__image-choose-compact"
		>

			<van-field
				:label="current.title"
				:label-class="{'readonly-field-label': !isRead && isReadOnly}"
				:required="Boolean(!isRead && current.required)"
			>
				<template #input>
					<div
						class="ry-form__image-choose-isRead"
						v-if="isRead"
					>
						<div
							v-for="opt in contentText"
							class="ry-form__image-choose-content"
						>
							<div>
								<van-image
									width="80"
									height="80"
									:src="opt.optionImage"
									fit="cover"
								></van-image>
							</div>
							<span>{{ opt.optionName }}</span>
						</div>
					</div>

					<div v-if="isRead && (!current.value || !current.value.length)">
						暂无内容
					</div>
				</template>
			</van-field>

		</div> -->
	</div>

</template>

<script>
	import {
		current
	} from './mixin'

	export default {
		mixins: [current],
		computed: {
			contentText() {
				if (this.current.value && this.current.value.length) {
					return this.current.options
						.filter(opt => this.current.value.includes(opt.id))
				} else {
					return []
				}
			}
		}
	}
</script>
